export default __webpack_public_path__ + "static/illustration-avatar.url-0622bfd7f024e494302936a9a404bb95.svg";